import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { styled, useTheme } from '@mui/material/styles';
import { Box, IconButton, Grid, ClickAwayListener, Paper, Grow, Typography, useMediaQuery } from '@mui/material';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import MenuIcon from '@mui/icons-material/Menu';
//import ReplayIcon from '@mui/icons-material/Replay';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import RefreshIcon from '@mui/icons-material/Refresh';

import AnimationSpeedSlider from '../ui-controls/animation-speed-slider.js';

//ToDo: swap this for sx styles where applicable (breakpoints work but theme colors do not)
const useStyles = makeStyles((theme) => ({
//    button : {
//        color:'white',
//        backgroundColor:'rgba(0,0,0,0.6)',
//        '&:hover': {
//            backgroundColor: '#005194' //theme.palette.primary.main,
//        },
//    },
//    buttonContainerLg: {
//        marginLeft: '4em'
//    },
//    buttonContainerSm: {
//        marginLeft: '1em'
//    },
    menuContainer: {
        position: 'absolute',
        bottom: '6em',
        right: '20%',
        padding: '1em 2em',
        width: '12em',
        zIndex: '1100',
        [theme.breakpoints.down('xl')]: { // lg
            bottom: '6em',
            right: '22%',
        },
        [theme.breakpoints.down('lg')]: { // md
            bottom: '6em',
            right: '1em',
        },
        [theme.breakpoints.down('sm')]: { // xs
            bottom: '6em',
            right: '1em',
        },
    }
}));

let sxStyles = {
    buttons : {
        color:'white',
        backgroundColor:'rgba(0,0,0,0.6)',
        '&:hover': {
            backgroundColor: 'primary.main',
        },
    },
    menuButtons : {
        color:'primary.main',
        backgroundColor:'white',
        '&:hover': {
            color:'white',
            backgroundColor: 'primary.main',
        },
    },
};

/**
* Collection of buttons for controlling time slider (except play currently)
*   @prop (float) animationSpeed - speed of animation in frames per second
*   @prop (func) setAnimationSpeed - callback function for setting animationSpeed
*   @prop (func) setSelectedTime - callback function for setting selected/current time
*   @prop (obj) capHandlers - Contains all capability handlers for each product
*   @prop (obj) buttonStyle - Contains definition for button style
**/
export function AnimationControlButtonsLg(props) {
    const classes = useStyles();

    const handleStepForward = () => {
        if (props.playing) {
            props.togglePlay();
        }
        props.stepAnimation();
    };

    const handleStepBack = () => {
        if (props.playing) {
            props.togglePlay();
        }
        props.stepAnimation('back');
    };

    return (
        <Grid container
            className={classes.buttonContainerLg}
            spacing={1}
            direction="row"
            justify="flex-start"
            alignItems="center"
        >
            <Grid item >
                <Box>
                    <IconButton size='small' sx={{...sxStyles.buttons}} onClick={handleStepBack}>
                        <KeyboardArrowLeftIcon />
                    </IconButton>
                </Box>
            </Grid>
            <Grid item >
                <Box>
                    <IconButton size='small' sx={sxStyles.buttons} onClick={handleStepForward} >
                        <KeyboardArrowRightIcon />
                    </IconButton>
                </Box>
            </Grid>
            <Grid item >
                <AnimationControlMenu
                    animationSpeed={props.animationSpeed}
                    setAnimationSpeed={props.setAnimationSpeed}
                />
            </Grid>
            <Grid item >
	            <RefreshCapsButton
	                setSelectedTime={props.setSelectedTime}
	                capHandlers={props.capHandlers}
					buttonStyle={sxStyles.buttons}
	            />
            </Grid>
        </Grid>
    );
}
//Note: code below removed from above component, nowCoast has no replay functionality. (it has a similar icon for refreshing slider which we currently do automatically)
// in either case functionality for this button has not yet been implemented
//<Grid item >
//    <Box >
//        <IconButton size='small' sx={sxStyles.buttons} >
//            <ReplayIcon  />
//        </IconButton>
//    </Box>
//</Grid>

/**
*   @prop (float) animationSpeed - speed of animation in frames per second
*   @prop (func) setAnimationSpeed - callback function for setting animationSpeed
*   @prop (func) setSelectedTime - callback function for setting selected/current time
*   @prop (obj) capHandlers - Contains all capability handlers for each product
**/
export function AnimationControlButtonsSm(props) {
    const classes = useStyles();

    return (
        <Grid container
            className={classes.buttonContainerSm}
            spacing={0}
            direction="row"
            justify="flex-start"
            alignItems="center"
        >
            <Grid item>
                <AnimationControlMenu
                    animationSpeed={props.animationSpeed}
                    setAnimationSpeed={props.setAnimationSpeed}
                    setSelectedTime={props.setSelectedTime}
                    capHandlers={props.capHandlers}
                />
            </Grid>
        </Grid>
    );
}

/**
*   @prop (float) animationSpeed - speed of animation in frames per second
*   @prop (func) setAnimationSpeed - callback function for setting animationSpeed
*   @prop (func) setSelectedTime - callback function for setting selected/current time
*   @prop (obj) capHandlers - Contains all capability handlers for each product
**/
function AnimationControlMenu(props) {
        const classes = useStyles();

    const [timeSliderMenuOn, setTimeSliderMenuOn] = useState(false);

    const toggleTimeSliderMenu = () => {
        const curState = timeSliderMenuOn;
        setTimeSliderMenuOn(!curState);
    }

    const handleClickAway = () => {
        setTimeSliderMenuOn(false);
        return;
    }

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <div>
                <IconButton size='small' sx={{...sxStyles.buttons}} onClick={toggleTimeSliderMenu} >
                    <MenuIcon />
                </IconButton>
                <Grow in={timeSliderMenuOn} style={{ transformOrigin: 'top right' }}>
                    <Paper elevation={3} className={classes.menuContainer} >
                        <TimeSliderMenuContent
                            animationSpeed={props.animationSpeed}
                            setAnimationSpeed={props.setAnimationSpeed}
                            setSelectedTime={props.setSelectedTime}
                            capHandlers={props.capHandlers}
                        />
                    </Paper>
                </Grow>
            </div>
        </ClickAwayListener>
    );
}

// *   @prop (func) setSelectedTime - callback function for setting selected/current time
// *   @prop (obj) capHandlers - Contains all capability handlers for each product
function TimeSliderMenuContent(props) {
    const theme = useTheme();

    let showRefreshCapsButton = false;
    if (useMediaQuery(theme.breakpoints.down('md'))) { // True if breakpoint is sm or xs
        showRefreshCapsButton = true;
    }
    
    let refreshCapsButton = 
    		<>
    			<div style={{display: "flex", justifyContent: "center", mt: "5px"}}>
					<RefreshCapsButton
						setSelectedTime={props.setSelectedTime}
						capHandlers={props.capHandlers}
						buttonStyle={sxStyles.menuButtons}
					/>
				</div>
		    	<Typography align="center" sx={{fontSize: "70%"}}>Refresh Services</Typography>
			</>;		
							
    return(
		<div>
			<Typography variant="subtitle2" align="center">Time Control Settings</Typography>
			<AnimationSpeedSlider
			    animationSpeed={props.animationSpeed}
			    setAnimationSpeed={props.setAnimationSpeed}
			/>
			<Typography align="center" sx={{fontSize: "70%", mb: "10px"}}>Animation Speed (Frames/Sec)</Typography>
			{(showRefreshCapsButton) ? refreshCapsButton : ""}
		</div>
	);

}

const IconLabelTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.contrastText,
        boxShadow: theme.shadows[2],
        fontSize: '65%',
        '& *' : {
            color: theme.palette.primary.light,
        }
    },
}));

/**
* Wrapper for conditionally rendering a tooltip only at cellphone size
*/
function CellPhoneToolTip(props) {
    const theme = useTheme();
    if (!useMediaQuery(theme.breakpoints.only('xs'))) {
        return(
            <IconLabelTooltip arrow title="Refresh Services" placement="top">
                {props.children}
            </IconLabelTooltip>
        );
    }
    return(
        <>
            {props.children}
        </>
    );
}

/**
* RefreshCapsButton clears selected time and forces cap handlers to grab latest capabilities
* As a result selectedTime gets set to presentTime as time slider is updated from new capabilities
*
*   @prop (func) setSelectedTime - callback function for setting selected/current time
*   @prop (obj) capHandlers - Contains all capability handlers for each product
*   @prop (obj) buttonStyle - Contains definition for button style
**/
function RefreshCapsButton(props) {

    let refreshCaps = () => {
        props.setSelectedTime(null);
        props.capHandlers.forEach(async (capHandler) => {
            await capHandler.handler.getCapabilities();
        });
    };

    return(
		<CellPhoneToolTip>
			<IconButton size='small' sx={props.buttonStyle} onClick={() => {refreshCaps()}} >
				<RefreshIcon />
			</IconButton>
		</CellPhoneToolTip>
    );
}
